"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "defaultSpacing", {
    enumerable: true,
    get: function() {
        return defaultSpacing;
    }
});
var defaultSpacing = {
    "spacer-px": "0.0625rem",
    "spacer-half": "0.125rem",
    "spacer-0": "0rem",
    "spacer-1": "0.25rem",
    "spacer-2": "0.5rem",
    "spacer-3": "0.75rem",
    "spacer-4": "1rem",
    "spacer-5": "1.25rem",
    "spacer-6": "1.5rem",
    "spacer-7": "1.75rem",
    "spacer-8": "2rem",
    "spacer-9": "2.25rem",
    "spacer-10": "2.5rem",
    "spacer-12": "3rem",
    "spacer-14": "3.5rem",
    "spacer-16": "4rem",
    "spacer-20": "5rem",
    "spacer-24": "6rem",
    "spacer-28": "7rem",
    "spacer-32": "8rem",
    "spacer-36": "9rem",
    "spacer-40": "10rem",
    "spacer-44": "11rem",
    "spacer-48": "12.25rem",
    "spacer-52": "13rem",
    "spacer-56": "14rem",
    "spacer-60": "15rem",
    "spacer-64": "16rem",
    "spacer-72": "18rem",
    "spacer-80": "20rem",
    "spacer-86": "24rem",
    "spacer-button-gap-L": "0.500rem",
    "spacer-button-y-L": "0.750rem",
    "spacer-button-x-L": "1.500rem",
    "spacer-button-gap-M": "0.500rem",
    "spacer-button-y-M": "0.500rem",
    "spacer-button-x-M": "1.000rem",
    "spacer-button-gap-S": "0.500rem",
    "spacer-button-y-S": "0.500rem",
    "spacer-button-x-S": "0.750rem",
    "spacer-button-gap-XS": "0.500rem",
    "spacer-button-y-XS": "0.250rem",
    "spacer-button-x-XS": "0.500rem",
    "spacer-button-icon-L": "0.875rem",
    "spacer-button-icon-M": "0.625rem",
    "spacer-button-icon-S": "0.625rem",
    "spacer-button-icon-XS": "0.250rem",
    "spacer-tag-gap-L": "0.25rem",
    "spacer-tag-y-L": "0.25rem",
    "spacer-tag-x-L": "0.75rem",
    "spacer-tag-gap-M": "0.25rem",
    "spacer-tag-y-M": "0.0625rem",
    "spacer-tag-x-M": "0.5rem",
    "spacer-tag-gap-S": "0.25rem",
    "spacer-tag-y-S": "0rem",
    "spacer-tag-x-S": "0.5rem"
};
